// frontend/src/services/api/creditAPI.js
import api from "./index";

// frontend/src/services/api/creditAPI.js
// const creditAPI = {
//   getBalance: () => api.get("/credits/balance"),
//   createPaymentIntent: (data) =>
//     api.post("/payment/create-payment-intent", data),
//   verifyPayment: (sessionId) => api.post(`/payment/verify/${sessionId}`),
// };

const creditAPI = {
  getBalance: () => api.get("/credits/balance"),
  createPaymentIntent: (data) =>
    api.post("/payment/create-payment-intent", data),
  verifyPayment: (sessionId) => api.post(`/payment/verify/${sessionId}`),

  // Add PayPal methods
  createPayPalOrder: (data) => api.post("/payment/paypal/create-order", data),
  capturePayPalOrder: (data) => api.post("/payment/paypal/capture-order", data),
};
export default creditAPI;
